/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Dropdown, Menu, Spin } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import GlobalService from '../../../services/Global.service';
import MyCompanyService from '../../../services/MyCompany.service';
import useNotify from '../../../context/Notification/useNotify';
import IconBack from '../../../assets/Images/icons/icon-back';
import UserService from '../../../services/UserService';
import ModalDelete from '../../../components/Shared/modal/delete';
import { ROUTER } from '../../../constants/router';

export default function MyCompany() {
    const { t } = useTranslation();
    const Navigate = useNavigate();
    const notify = useNotify();
    const [companyList, setCompanyList] = useState([]);
    const [selectCompany, setSelectCompany] = useState('');
    const [companyDetail, setCompanyDetail] = useState('');

    const [loadingForm, setLoadingForm] = useState(false);

    // ConfirmDelete
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);

    const getImage = async (logoId) => {
        try {
            const { data } = await GlobalService.getImage(logoId);
            if (data.resultData) {
                return data.resultData?.imageId;
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getCompany = async (companyName = null) => {
        setCompanyList([]);
        try {
            const { data } = await MyCompanyService.getCompanyList({
                companyName: companyName,
            });
            setCompanyList([]);
            if (data?.resultData) {
                let objectValue = [];
                if (data.resultData.length > 0) {
                    for (let _data of data?.resultData) {
                        let img = '';
                        if (_data?.companyLogoId) {
                            img = await getImage(_data?.companyLogoId);
                        }
                        objectValue.push({
                            img: img ? `data:image/jpeg;base64,${img}` : '',
                            ..._data,
                        });
                    }
                    objectValue.sort((a, b) => b.isRegistered - a.isRegistered);
                }
                setSelectCompany(objectValue[0]);
                setCompanyList(objectValue);
                setLoadingForm(false);
            }
        } catch (error) {
            console.log(error);
        }
    };
    // Role
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);

    useEffect(() => {
        if (admin) {
            setLoadingForm(true);
            getCompany();
        } else {
            Navigate('/not-found');
        }
    }, []);

    const menu = (app) =>
        !app?.domainCount || app?.domainCount <= 0 ? (
            app.isRegistered ? (
                <Menu
                    className="w-28"
                    items={[
                        {
                            label: t('common.Edit'),
                            key: '1',
                            onClick: () => {
                                Navigate(
                                    `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/my-company/${app.id}`
                                );
                            },
                        },
                    ]}
                />
            ) : (
                <Menu
                    className="w-28"
                    items={[
                        {
                            label: t('common.Edit'),
                            key: '1',
                            onClick: () => {
                                Navigate(
                                    `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/my-company/${app.id}`
                                );
                            },
                        },
                        {
                            label: t('common.Delete'),
                            key: '2',
                            onClick: () => {
                                setOpenConfirmDelete(true);
                                setCompanyDetail(app);
                            },
                        },
                    ]}
                />
            )
        ) : (
            <Menu
                className="w-28"
                items={[
                    {
                        label: t('common.Edit'),
                        key: '1',
                        onClick: () => {
                            Navigate(
                                `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/my-company/${app.id}`
                            );
                        },
                    },
                ]}
            />
        );

    return (
        <>
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        // setBackAction(true)
                        // navigate('/dc-dpo');
                        Navigate(ROUTER.CONFIGURATION.USER_MANAGEMENT);
                    }}
                >
                    <IconBack />
                </div>
                <span>{t('My Company') || '-'}</span>
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('common.Configuration')} / {t('User Management')} /
                </span>
                <span> {t('My Company')} </span>
            </div>
            {/* Search bar */}
            <div className="my-4 space-y-4">
                <Spin spinning={loadingForm}>
                    <div className="w-full rounded-md bg-white p-6">
                        <div className="font-semibold whitespace-nowrap mr-6">
                            <div className="text-xl">{t('My Company')}</div>
                            <div className="text-xs font-medium text-gray-PHX mt-2">
                                {t('TotalItems', {
                                    length: companyList?.length,
                                })}
                            </div>
                        </div>
                        <div className="p-2 py-4 grid grid-cols-5 gap-4 overflow-auto h-96">
                            {companyList?.map((app) => {
                                return (
                                    <>
                                        <div className="relative">
                                            <div
                                                className="flex flex-col rounded-xl p-4 h-40 hover:shadow-purple-100 hover:shadow-lg duration-100 cursor-pointer"
                                                style={{
                                                    border:
                                                        selectCompany?.id ===
                                                        app.id
                                                            ? '1px solid #7B67FB'
                                                            : '1px solid #DBDBDB',
                                                }}
                                                // onClick={() => setSelectCompany(app)}
                                                onClick={() => {
                                                    setSelectCompany(app);
                                                    Navigate(
                                                        `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/my-company/domain/${app.id}`,
                                                        { state: { app } }
                                                    );
                                                }}
                                            >
                                                <div className="text-base mt-10 font-medium">
                                                    {app?.companyName}
                                                </div>
                                                <div
                                                    className="text-10 font-normal"
                                                    style={{ color: '#A8A8AF' }}
                                                >
                                                    {app?.domainCount
                                                        ? app?.domainCount
                                                        : 0}{' '}
                                                    {t('Domain')}
                                                </div>
                                                <p
                                                    className="text-10 font-medium"
                                                    style={{ color: '#7B67FB' }}
                                                >
                                                    {app?.isRegistered
                                                        ? t(
                                                              'MyCompany.RegisteredCompany'
                                                          )
                                                        : ''}
                                                </p>
                                            </div>
                                            <div className="flex justify-between items-center z-10 absolute top-0 left-0 p-4">
                                                {app.img ? (
                                                    // eslint-disable-next-line jsx-a11y/img-redundant-alt
                                                    <img
                                                        className="w-10 h-10 rounded-full object-cover"
                                                        src={app.img}
                                                        alt="image"
                                                    />
                                                ) : (
                                                    svgNoImage
                                                )}
                                            </div>
                                            <div className="flex justify-between items-center z-10 absolute top-0 right-0 p-4">
                                                <Dropdown
                                                    overlay={menu(app)}
                                                    trigger={['click']}
                                                >
                                                    <a
                                                        onClick={(e) =>
                                                            e.preventDefault()
                                                        }
                                                    >
                                                        {svgIcon3}
                                                    </a>
                                                </Dropdown>
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                        </div>
                    </div>
                </Spin>
            </div>

            <ModalDelete
                title={t('common.ConfirmDelete')}
                text={t('MyCompany.DoYouWantDeleteCompany', {
                    companyName: companyDetail?.companyName,
                })}
                open={openConfirmDelete}
                handelOk={() => {
                    MyCompanyService.deleteCompany(companyDetail.id)
                        .then((res) => {
                            setOpenConfirmDelete(false);
                            notify({
                                title: t('common.Success'),
                                description: t(
                                    'dataFlow.SuccessfullyToClearData'
                                ),
                            });
                            getCompany();
                        })
                        .catch((err) => {
                            setOpenConfirmDelete(false);
                            notify({
                                type: 'error',
                                title: t('common.Fail'),
                                description: t('dataFlow.FailedToClearData'),
                            });
                        });
                }}
                handelClose={() => setOpenConfirmDelete(false)}
            />
        </>
    );
}

const svgIcon3 = (
    <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width={32} height={32} rx={6} fill="#F3F6F9" />
        <path
            d="M19.75 16C19.75 17.0312 20.5937 17.875 21.625 17.875C22.6562 17.875 23.5 17.0312 23.5 16C23.5 14.9688 22.6562 14.125 21.625 14.125C20.5938 14.125 19.75 14.9687 19.75 16Z"
            fill="#7B67FB"
        />
        <path
            d="M17.875 16C17.875 14.9688 17.0312 14.125 16 14.125C14.9688 14.125 14.125 14.9687 14.125 16C14.125 17.0312 14.9687 17.875 16 17.875C17.0312 17.875 17.875 17.0312 17.875 16Z"
            fill="#7B67FB"
        />
        <path
            d="M12.25 16C12.25 14.9688 11.4062 14.125 10.375 14.125C9.34375 14.125 8.5 14.9687 8.5 16C8.5 17.0312 9.34375 17.875 10.375 17.875C11.4062 17.875 12.25 17.0312 12.25 16Z"
            fill="#7B67FB"
        />
    </svg>
);

export const svgNoImage = (
    <svg
        width={40}
        height={40}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx={20} cy={20} r={20} fill="#EDEEF9" />
        <g opacity="0.5">
            <path
                d="M27 11H13C11.8954 11 11 11.8954 11 13V27C11 28.1046 11.8954 29 13 29H27C28.1046 29 29 28.1046 29 27V13C29 11.8954 28.1046 11 27 11Z"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.5 18C17.3284 18 18 17.3284 18 16.5C18 15.6716 17.3284 15 16.5 15C15.6716 15 15 15.6716 15 16.5C15 17.3284 15.6716 18 16.5 18Z"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29 23L24 18L13 29"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);
